import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ModalController } from '@ionic/angular';

import { ProductSupplier } from '../models';
import { List } from 'immutable';

import { ProductSupplierService } from '../services/product-supplier.service';
import { SupplierFormPage } from './supplier-form/supplier-form.page';

import { Storage } from '@ionic/storage-angular';
import { Platform } from '@ionic/angular';

@Component({
  selector: 'app-suppliers',
  templateUrl: './suppliers.page.html',
  styleUrls: ['./suppliers.page.scss'],
})
export class SuppliersPage implements OnInit {

  public isLoading: boolean = true;
  public errorOccurredWhileLoadingProducts: boolean = false;

  public errorOccurredWhileSearching: boolean;
  public productSuppliers: List<ProductSupplier>;

  public isMobile: boolean = false;

  constructor(
    private productSupplierService: ProductSupplierService,
    private changeDetectorRef: ChangeDetectorRef,
    private modalCtrl: ModalController,
    private storage: Storage,
    private platform: Platform
  ) {
    this.isLoading = true;
  }

  ngOnInit() {
    this.loadSuppliers();
    this.platform.ready().then(() => {
      if (
        this.platform.is('mobile') ||
        this.platform.is('android') ||
        this.platform.is('iphone') ||
        this.platform.is('mobileweb')
      ) {
        this.isMobile = true;
      }
    });
  }

  public loadSuppliers(){
    this.productSupplierService.loadProductSuppliers().subscribe({
      next: (productSuppliers) => {
        this.isLoading = false;
        this.productSuppliers = productSuppliers;
        this.changeDetectorRef.markForCheck();
      },
      error: (err) => {
        this.isLoading = false;
        this.errorOccurredWhileLoadingProducts = true;
        this.changeDetectorRef.markForCheck();
      },
    });
  }

  async create(){
    let collapsed = await this.storage.get("collapsed");
    const cssClassName = collapsed ? "modal-fullscreen-c" : "modal-fullscreen"
    const modal = await this.modalCtrl.create({
      component: SupplierFormPage,
      cssClass: cssClassName,
    })

    modal.present();
    modal.onWillDismiss().then((data) => {
      if(data.data){
        this.loadSuppliers()
      }
    })
  }
  
  async edit(supplier){
    let collapsed = await this.storage.get("collapsed");
    const cssClassName = collapsed ? "modal-fullscreen-c" : "modal-fullscreen"
    const modal = await this.modalCtrl.create({
      component: SupplierFormPage,
      componentProps: { productSupplierID: supplier.id},
      cssClass: cssClassName,
    })

    modal.present();
    modal.onWillDismiss().then((data) => {
      if(data.data){
        this.loadSuppliers()
      }
    })
  }

  onTapToReload() {
    this.loadSuppliers();
  }

}
